import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  // Use WritableSignal to allow updates
  private _data: WritableSignal<{ [key: string]: any }> = signal({});

  // Getter for readonly access
  get data() {
    return this._data;
  }

  // Function to update the signal's value
  updateData(newData: any) {
    this._data.set(newData); // Set the new value directly
  }
  
  // New function to explicitly reset the signal
  resetSignal() {
    this._data.set({});
  }
  
  // Send a one-time signal that automatically resets
  sendOneTimeSignal(signalData: any) {
    // First set the signal
    this._data.set(signalData);
    
    // Schedule a reset outside of Angular's reactive context
    setTimeout(() => {
      this._data.set({});
    }, 100);
  }
}